"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.parse-int.js");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _formElements = require("@evidation/form-elements");

var _rcSlider = _interopRequireDefault(require("rc-slider"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../utils");

var _reactReduxToastr = require("react-redux-toastr");

var _useTranslated = require("../../hooks/useTranslated");

require("rc-slider/assets/index.css");

var _excluded = ["slider_horizontal_orientation", "label", "slider_question", "slider_value_text", "slider_min", "slider_min_label", "slider_max", "slider_max_label", "slider_steps", "marks_range_slider", "slider_custom_height", "input", "t"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "rangeSlider__Container"
})(["display:grid;grid-template:auto 1fr / 1fr 1fr;height:", ";align-items:center;padding:30px 0;span,p,.rc-slider{justify-self:center;align-self:center;}.sliderQuestion p{margin:0;}"], function (props) {
  return props.height ? "".concat(props.height, "px") : 'auto';
});

var Question = _styledComponents["default"].div.withConfig({
  displayName: "rangeSlider__Question"
})(["grid-column:1 / 3;grid-row:1 / 2;justify-self:center;"]);

var MarksLabel = _styledComponents["default"].div.withConfig({
  displayName: "rangeSlider__MarksLabel"
})(["div p{margin:0;}"]);

var MarksMinMax = _styledComponents["default"].div.withConfig({
  displayName: "rangeSlider__MarksMinMax"
})(["p{margin:16px;}"]);

var SliderValueBox = _styledComponents["default"].div.withConfig({
  displayName: "rangeSlider__SliderValueBox"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:black;color:white;margin:0 30%;span{margin-bottom:10px;font-size:1.5rem;}div p{color:white;text-align:center;}"]);

var Label = _styledComponents["default"].div.withConfig({
  displayName: "rangeSlider__Label"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;"]);

var SliderContainer = _styledComponents["default"].div.withConfig({
  displayName: "rangeSlider__SliderContainer"
})(["margin:0 20px;align-self:stretch;justify-content:center;display:flex;flex-direction:", ";justify-content:center;align-items:center;"], function (props) {
  return props.vertical ? 'column' : 'horizontal';
});

var RangeSlider = function RangeSlider(_ref) {
  var slider_horizontal_orientation = _ref.slider_horizontal_orientation,
      label = _ref.label,
      slider_question = _ref.slider_question,
      slider_value_text = _ref.slider_value_text,
      _ref$slider_min = _ref.slider_min,
      slider_min = _ref$slider_min === void 0 ? 0 : _ref$slider_min,
      slider_min_label = _ref.slider_min_label,
      _ref$slider_max = _ref.slider_max,
      slider_max = _ref$slider_max === void 0 ? 100 : _ref$slider_max,
      slider_max_label = _ref.slider_max_label,
      slider_steps = _ref.slider_steps,
      _ref$marks_range_slid = _ref.marks_range_slider,
      marks_range_slider = _ref$marks_range_slid === void 0 ? [] : _ref$marks_range_slid,
      _ref$slider_custom_he = _ref.slider_custom_height,
      slider_custom_height = _ref$slider_custom_he === void 0 ? 400 : _ref$slider_custom_he,
      input = _ref.input,
      t = _ref.t,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      sliderValue = _useState2[0],
      setSliderValue = _useState2[1];

  var ERROR_MSG = (0, _useTranslated.useTranslated)('components.rangeSlider.maxMinEntryError');
  var marks = marks_range_slider.reduce(function (marks, _ref2) {
    var position = _ref2.position,
        label = _ref2.label;
    marks[position] = /*#__PURE__*/_react["default"].createElement(MarksLabel, null, /*#__PURE__*/_react["default"].createElement(Label, null, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, label)));
    return marks;
  }, {});
  (0, _react.useEffect)(function () {
    if (parseInt(slider_min) > parseInt(slider_max)) {
      _reactReduxToastr.toastr.error(ERROR_MSG);
    }
  }, [ERROR_MSG, slider_max, slider_min]);

  var handleOnChange = function handleOnChange(value) {
    setSliderValue(value);
    input.onChange(value);
  };

  return /*#__PURE__*/_react["default"].createElement(Container, {
    height: slider_custom_height
  }, /*#__PURE__*/_react["default"].createElement(Question, {
    className: "sliderQuestion"
  }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, slider_question)), /*#__PURE__*/_react["default"].createElement(SliderValueBox, null, /*#__PURE__*/_react["default"].createElement(Label, null, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, slider_value_text)), /*#__PURE__*/_react["default"].createElement("span", null, sliderValue)), /*#__PURE__*/_react["default"].createElement(SliderContainer, {
    vertical: !slider_horizontal_orientation
  }, /*#__PURE__*/_react["default"].createElement(MarksMinMax, null, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, !slider_horizontal_orientation ? slider_max_label : slider_min_label)), /*#__PURE__*/_react["default"].createElement(_rcSlider["default"], (0, _extends2["default"])({
    "aria-label": (0, _utils.stripHtml)(label),
    onChange: handleOnChange,
    valueLabelDisplay: "auto",
    step: slider_steps ? parseInt(slider_steps) : undefined,
    marks: marks,
    min: parseInt(slider_min),
    max: parseInt(slider_max),
    vertical: !slider_horizontal_orientation
  }, props)), /*#__PURE__*/_react["default"].createElement(MarksMinMax, null, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, !slider_horizontal_orientation ? slider_min_label : slider_max_label))));
};

var _default = RangeSlider;
exports["default"] = _default;